import { useEffect, useState } from "react";
import { loadVdocipherWebComponentPlayer } from "../../../helpers/vdocipherWebComponent.js";

/**
 * Loads VdoCipher v2 web component (`player.js`). Same script as `<vdocipher-player />`.
 * `isAPIReady` kept for callers (e.g. VideoStatusUsingAPI).
 */
export default function useVdocipher() {
    const [isAPIReady, setIsAPIReady] = useState(false);

    useEffect(() => {
        loadVdocipherWebComponentPlayer().then(() => setIsAPIReady(true));
    }, []);

    return { isAPIReady };
}
